/**
 *
 * 懒加载动态路由
 */
function lazy(code) {
  //return  () => import( /* webpackChunkName: 'async-components' */  "@/components/" + name + ".vue")
  return getComponetByPath('/' + code);
}

function getComponetByPath(path) {
  for (var i = 0; i < dynamicRouter.length; i++) {
    var route = dynamicRouter[i];
    if (route.path == path) {
      return route
    }
  }
}
/**
 * 路由定义
 * path跟配置里的资源标示对应,同时跟url地址对应
 */
const dynamicRouter = [
  {
    name: 'index',
    path: '/index',
    component: () => import( /* webpackChunkName: 'index_page' */ '@/components/index.vue'),
    meta: {
      title: '我的工作台'
    }
  },
  {
    name: 'myTask',
    path: '/myTask',
    redirect: '/myTaskList',
    // component: () => import( /* webpackChunkName: 'my_task' */ '@/components/workIndex/myTask.vue'),
    // meta: {
    //   title: '我的任务'
    // }
  },
  {
    name: 'OrganizationTree',
    path: '/organizationTree',
    component: () => import( /* webpackChunkName: 'organization_tree' */  '@/components/admin/OrganizationTree.vue'),
    meta: { title: '机构管理' }
  },
  {
    name: 'SysMenu',
    path: '/sysMenu',
    component: () => import( /* webpackChunkName: 'sys_menu' */  '@/components/admin/SysMenu.vue'),
    meta: { title: '菜单管理' }
  },
  {
    name: 'allCustomer',
    path: '/allCustomer',
    component: () => import( /* webpackChunkName: 'all_customer */  '@/components/customer/allCustomer.vue'),
    meta: {
      title: '全部客户'
    }
  },
  {
    name: 'myCustomer',
    path: '/myCustomer',
    component: () => import( /* webpackChunkName: 'my_customer' */  '@/components/customer/myCustomer.vue'),
    meta: {
      title: '我的客户'
    }
  },

  {
    name: 'customermanage',
    path: '/customermanage',
    component: () => import( /* webpackChunkName: 'customer_manage' */  '@/components/customer/customermanage.vue'),
    meta: {
      title: '客户来源'
    }
  },

  {
    name: 'recycle',
    path: '/recycle',
    component: () => import( /* webpackChunkName: 'customer_recycle' */  '@/components/customer/recycle.vue'),
    meta: {
      title: '客户回收站'
    }
  },
  {
    name: 'labelManage',
    path: '/labelManage',
    component: () => import( /* webpackChunkName: 'label_manage' */  '@/components/customer/labelManage.vue'),
    meta: {
      title: '标签管理'
    }
  },
  {
    name: 'coupon',
    path: '/coupon',
    component: () => import( /* webpackChunkName: 'coupon_manage' */  '@/components/customer/coupon.vue'),
    meta: {
      title: '优惠券'
    }
  },

  // {
  //   name: 'orderList',
  //   path: '/orderList',
  //   component: () => import( /* webpackChunkName: 'order_list' */  '@/components/order/orderList.vue'),
  //   meta: { title: '订单列表' }
  // },
  // {
  //   name: 'handoverform',
  //   path: '/handoverform',
  //   component: () => import( /* webpackChunkName: 'handover_form' */  '@/components/order/handoverform.vue'),
  //   meta: { title: '交接单管理' }
  // },
  {
    name: 'companyList',
    path: '/companyList',
    component: () => import( /* webpackChunkName: 'company_list' */  '@/components/order/companyList.vue'),
    meta: { title: '企业列表' }
  },
  // {
  //   name: 'companymanage',
  //   path: '/companymanage',
  //   component: () => import( /* webpackChunkName: 'company_manage' */  '@/components/order/companymanage.vue'),
  //   meta: {
  //     title: '企业服务管理'
  //   }
  // },
  // {
  //   name: 'renew',
  //   path: '/renew',
  //   component: () => import( /* webpackChunkName: 'renew' */  '@/components/order/renew.vue'),
  //   meta: {
  //     title: '续费管理'
  //   }
  // },
  {
    name: 'paymentRecord',
    path: '/paymentRecord',
    component: () => import( /* webpackChunkName: 'payment_record' */  '@/components/order/paymentRecord.vue'),
    meta: {
      title: '支付记录'
    }
  },
  // {
  //   name: 'checkOrder',
  //   path: '/checkOrder',
  //   component: () => import( /* webpackChunkName: 'check_order' */  '@/components/order/checkOrder.vue'),
  //   meta: {
  //     title: '订单审核'
  //   }
  // },
  // {
  //   name: 'sourceOrder',
  //   path: '/sourceOrder',
  //   component: () => import( /* webpackChunkName: 'source_order' */  '@/components/order/sourceOrder.vue'),
  //   meta: {
  //     title: '订单来源'
  //   }
  // },
  {
    name: 'financeInvoice',
    path: '/financeInvoice',
    component: () => import( /* webpackChunkName: 'finance_invoice' */  '@/components/invoice/financeInvoice.vue'),
    meta: {
      title: '财务开票管理'
    }
  },
  {
    name: 'taxationInvoice',
    path: '/taxationInvoice',
    component: () => import( /* webpackChunkName: 'taxation_invoice' */  '@/components/invoice/taxationInvoice.vue'),
    meta: {
      title: '财税开票管理'
    }
  },
  // {
  //   name: 'myOrder',
  //   path: '/myOrder',
  //   component: () => import( /* webpackChunkName: 'my_order' */  '@/components/order/myOrder.vue'),
  //   meta: {
  //     title: '我的订单'
  //   }
  // },

  //订单回收站
  // {
  //   name: 'orderRecycle',
  //   path: '/orderRecycle',
  //   component: () => import( /* webpackChunkName: 'order_recycle' */  '@/components/order/orderRecycle.vue'),
  //   meta: {
  //     title: '订单回收站'
  //   }
  // },



  // {
  //   name: 'providerService',
  //   path: '/providerService',
  //   component: () => import( /* webpackChunkName: 'provider_service' */  '@/components/order/providerService.vue'),
  //   meta: {
  //     title: '服务商管理'
  //   }
  // },

  {
    name: 'PayConfigure',
    path: '/payConfigure',
    component: () => import( /* webpackChunkName: 'pay_configure' */  '@/components/admin/PayConfigure.vue'),
    meta: {
      title: '支付配置'
    }
  },
  {
    name: 'SmsConfigure',
    path: '/smsConfigure',
    component: () => import( /* webpackChunkName: 'sms_configure' */  '@/components/admin/SmsConfigure.vue'),
    meta: {
      title: '短信配置'
    }
  },
  {
    name: 'banner',
    path: '/banner',
    component: () => import( /* webpackChunkName: 'banner' */  '@/components/website/banner.vue'),
    meta: {
      title: 'banner管理'
    }
  },
  {
    name: 'linking',
    path: '/linking',
    component: () => import( /* webpackChunkName: 'linking' */  '@/components/website/linking.vue'),
    meta: {
      title: '友情链接'
    }
  },
  {
    name: 'pagesetup',
    path: '/pagesetup',
    component: () => import( /* webpackChunkName: 'pagesetup' */  '@/components/website/pagesetup.vue'),
    meta: {
      title: '页面配置'
    }
  },
  {
    name: 'externalcode',
    path: '/externalcode',
    component: () => import( /* webpackChunkName: 'external_code' */  '@/components/website/externalcode.vue'),
    meta: {
      title: '外部代码'
    }
  },
  {
    name: 'contracttemplate',
    path: '/contracttemplate',
    component: () => import( /* webpackChunkName: 'contract_template' */  '@/components/website/contracttemplate.vue'),
    meta: {
      title: '合同模板'
    }
  },
  {
    name: 'agreement',
    path: '/agreement',
    component: () => import( /* webpackChunkName: 'agreement' */  '@/components/website/agreement.vue'),
    meta: {
      title: '注册协议'
    }
  },
  {
    name: 'seoconfigure',
    path: '/seoconfigure',
    component: () => import( /* webpackChunkName: 'seo_configure' */  '@/components/website/seoconfigure.vue'),
    meta: {
      title: 'SEO配置'
    }
  },
  {
    name: 'forum',
    path: '/forum',
    component: () => import( /* webpackChunkName: 'forum' */  '@/components/website/forum.vue'),
    meta: {
      title: '问答管理'
    },
  },
  {
    name: 'newsManage',
    path: '/newsManage',
    component: () => import( /* webpackChunkName: 'news_manage' */  '@/components/website/newsManage.vue'),
    meta: {
      title: '新闻资讯'
    },
  },
  {
    name: 'transferCompany',
    path: '/transferCompany',
    component: () => import( /* webpackChunkName: 'transfer_company' */  '@/components/website/transferCompany.vue'),
    meta: {
      title: '公司转让'
    },
  },
  {
    name: 'packageSite',
    path: '/packageSite',
    component: () => import( /* webpackChunkName: 'package_site' */  '@/components/website/packageSite.vue'),
    meta: {
      title: '套餐管理'
    },
  },
  // {
  //   name: 'classification',
  //   path: '/classification',
  //   component: () => import( /* webpackChunkName: 'classification' */  '@/components/product/classification.vue'),
  //   meta: {
  //     title: '分类管理'
  //   }
  // },
  // {
  //   name: 'productSet',
  //   path: '/productSet',
  //   component: () => import( /* webpackChunkName: 'product_set' */  '@/components/product/productSet.vue'),
  //   meta: {
  //     title: '产品设置'
  //   }
  // },
  // {
  //   name: 'skuList',
  //   path: '/skuList',
  //   component: () => import( /* webpackChunkName: 'sku_list' */  '@/components/product/skuList.vue'),
  //   meta: {
  //     title: '商品设置'
  //   }
  // },
  // {
  //   name: 'attributeProduct',
  //   path: '/attributeProduct',
  //   component: () => import( /* webpackChunkName: 'attribute_product' */  '@/components/product/attributeProduct.vue'),
  //   meta: {
  //     title: '属性管理'
  //   }
  // },
  // {
  //   name: 'businessProduct',
  //   path: '/businessProduct',
  //   component: () => import( /* webpackChunkName: 'business_product' */  '@/components/product/businessProduct.vue'),
  //   meta: {
  //     title: '业务管理'
  //   }
  // },
  {
    name: 'zbCustomer',
    path: '/zbCustomer',
    component: () => import( /* webpackChunkName: 'zb_customer' */  '@/components/sourcCrowd/zbCustomer.vue'),
    meta: {
      title: '客户管理'
    }
  },
  {
    name: 'zbOrder',
    path: '/zbOrder',
    component: () => import( /* webpackChunkName: 'zb_order' */  '@/components/sourcCrowd/zbOrder.vue'),
    meta: {
      title: '订单管理'
    }
  },
  //地址管理
  // {
  //   name: 'channelManage',
  //   path: '/channelManage',
  //   component: () => import( /* webpackChunkName: 'channel_manage' */  '@/components/address/channelManage.vue'),
  //   meta: {
  //     title: '地址渠道管理'
  //   }
  // },
  // {
  //   name: 'addressInfo',
  //   path: '/addressInfo',
  //   component: () => import( /* webpackChunkName: 'address_info' */  '@/components/address/addressInfo.vue'),
  //   meta: {
  //     title: '地址信息管理'
  //   }
  // },


  //城市合伙人
  {
    name: 'examineManage',
    path: '/examineManage',
    component: () => import( /* webpackChunkName: 'examine_manage' */  '@/components/cityPartner/examineManage.vue'),
    meta: {
      title: '线索订单'
    }
  },
  {
    name: 'referrer',
    path: '/referrer',
    component: () => import( /* webpackChunkName: 'referrer' */  '@/components/cityPartner/referrer.vue'),
    meta: {
      title: '推荐订单'
    }
  },
  //工作指南  OA
  {
    name: 'handBook',
    path: '/handBook',
    component: () => import( /* webpackChunkName: 'hand_book' */  '@/components/staffGuide/handBook.vue'),
    meta: {
      title: '工作手册'
    }
  },
  {
    name: 'orderSystem',
    path: '/orderSystem',
    component: () => import( /* webpackChunkName: 'order_system' */  '@/components/staffGuide/orderSystem.vue'),
    meta: {
      title: '点餐列表'
    }
  },
  {
    name: 'orderBack',
    path: '/orderBack',
    component: () => import( /* webpackChunkName: 'order_back' */  '@/components/staffGuide/orderBack.vue'),
    meta: {
      title: '点餐后台'
    }
  },

  {
    name: 'journal',
    path: '/journal',
    component: () => import( /* webpackChunkName: 'journal' */  '@/components/staffGuide/journal.vue'),
    meta: {
      title: '日志'
    }
  },
  {
    name: 'examine',
    path: '/examine',
    component: () => import( /* webpackChunkName: 'examine' */  '@/components/staffGuide/examine.vue'),
    meta: {
      title: '审批'
    }
  },
  {
    name: 'achievements',
    path: '/achievements',
    component: () => import( /* webpackChunkName: 'achievements' */  '@/components/staffGuide/achievements.vue'),
    meta: {
      title: '绩效'
    }
  },

  // {
  //   name: 'budgetPage',
  //   path: '/budgetPage',
  //   component: () => import( /* webpackChunkName: 'budget_page' */  '@/components/account/budgetPage.vue'),
  //   meta: {
  //     title: '预算'
  //   }
  // },
  // 积分
  {
    name: 'integral',
    path: '/integral',
    component: () => import( /* webpackChunkName: 'integral' */  '@/components/staffGuide/common/integral/integral.vue'),
    meta: {
      title: '积分'
    }
  },


  //公众号
  {
    name: 'fansList',
    path: '/fansList',
    component: () => import( /* webpackChunkName: 'fans_list' */  '@/components/weChatOfficial/fansList.vue'),
    meta: {
      title: '粉丝列表'
    }
  },
  {
    name: 'management',
    path: '/management',
    component: () => import( /* webpackChunkName: 'fans_rank' */  '@/components/weChatOfficial/management.vue'),
    meta: {
      title: '粉丝/排行榜'
    }
  },
  {
    name: 'order',
    path: '/order',
    component: () => import( /* webpackChunkName: 'order_list' */  '@/components/weChatOfficial/order.vue'),
    meta: {
      title: '订单列表'
    }
  },
  {
    name: 'wechatMenu',
    path: '/wechatMenu',
    component: () => import( /* webpackChunkName: 'wechat_menu' */  '@/components/weChatOfficial/wechatMenu.vue'),
    meta: {
      title: '菜单管理'
    }
  },
  {
    name: 'dogai',
    path: '/dogai',
    component: () => import( /* webpackChunkName: 'dogai' */  '@/components/weChatOfficial/dogai.vue'),
    meta: {
      title: '智能写作'
    }
  },
  {
    name: 'bargain',
    path: '/bargain',
    component: () => import( /* webpackChunkName: 'bargain' */  '@/components/weChatOfficial/bargain.vue'),
    meta: {
      title: '砍价小程序'
    }
  },
  {
    name: 'questionnaire',
    path: '/questionnaire',
    component: () => import( /* webpackChunkName: 'questionnaire' */  '@/components/weChatOfficial/questionnaire.vue'),
    meta: {
      title: '问卷调查'
    }
  },

  //记账管理
  // {
  //   name: 'bookkeep',
  //   path: '/bookkeep',
  //   component: () => import( /* webpackChunkName: 'bookkeep_manage' */  '@/components/finance/bookkeep.vue'),
  //   meta: {
  //     title: '记账列表'
  //   }
  // },
  // {
  //   name: 'bankingService',
  //   path: '/bankingService',
  //   component: () => import( /* webpackChunkName: 'banking_service' */  '@/components/finance/bankingService.vue'),
  //   meta: {
  //     title: '银行服务'
  //   }
  // },


  //财务系统
  //账户统计
  {
    name: 'Accountcalculat',
    path: '/Accountcalculat',
    component: () => import( /* webpackChunkName: 'accountcalculat_stats' */  '@/components/account/Accountcalculat.vue'),
    meta: {
      title: '资金流水'
    }
  },
  {
    name: 'income',
    path: '/income',
    component: () => import( /* webpackChunkName: 'income_stats' */  '@/components/account/income.vue'),
    meta: {
      title: '销售统计'
    }
  },
  // {
  //   name: 'renwStats',
  //   path: '/renwStats',
  //   component: () => import( /* webpackChunkName: 'renw_stats' */  '@/components/account/renwStats.vue'),
  //   meta: {
  //     title: '续费统计'
  //   }
  // },
  {
    name: 'expend',
    path: '/expend',
    component: () => import( /* webpackChunkName: 'expend_stats' */  '@/components/account/expend.vue'),
    meta: {
      title: '工资统计'
    }
  },
  {
    name: 'reimbursement',
    path: '/reimbursement',
    component: () => import( /* webpackChunkName: 'reimbursement' */  '@/components/account/reimbursement.vue'),
    meta: {
      title: '报销统计'
    }
  },

  //客户账务
  {
    name: 'companyAccount',
    path: '/companyAccount',
    component: () => import( /* webpackChunkName: 'company_account' */  '@/components/account/companyAccount.vue'),
    meta: {
      title: '客户账务'
    }
  },

  // {
  //   name: 'partnerInfo',
  //   path: '/partnerInfo',
  //   component: () => import( /* webpackChunkName: 'partner_info' */  '@/components/address/partnerInfo.vue'),
  //   meta: {
  //     title: '合作商列表'
  //   }
  // },


  //系统日志
  {
    name: 'systemLog',
    path: '/systemLog',
    component: () => import( /* webpackChunkName: 'system_log' */  '@/components/admin/systemLog.vue'),
    meta: {
      title: '系统日志'
    }
  },


  //邦邦豆
  // {
  //   name: 'bbBean',
  //   path: '/bbBean',
  //   component: () => import( /* webpackChunkName: 'bb_bean' */  '@/components/account/bbBean.vue'),
  //   meta: {
  //     title: '邦邦豆'
  //   }
  // },


  //工单列表
  {
    name: 'workOrder',
    path: '/workOrder',
    component: () => import( /* webpackChunkName: 'work_order' */  '@/components/staffGuide/workOrder.vue'),
    meta: {
      title: '工单'
    }
  },
  //热门推荐
  // {
  //   name: 'setMealProdict',
  //   path: '/setMealProdict',
  //   component: () => import( /* webpackChunkName: 'set_meal_prodict' */  '@/components/product/setMealProdict.vue'),
  //   meta: {
  //     title: '热门推荐'
  //   }
  // },
  //报名管理
  {
    name: 'lectureApply',
    path: '/lectureApply',
    component: () => import( /* webpackChunkName: 'lecture_apply' */  '@/components/customer/lectureApply.vue'),
    meta: {
      title: '讲座报名'
    }
  },
  //报名管理
  {
    name: 'lectureFeedback',
    path: '/lectureFeedback',
    component: () => import( /* webpackChunkName: 'lecture_feedback' */  '@/components/customer/lectureFeedback.vue'),
    meta: {
      title: '讲座反馈'
    }
  },
  //积分中心
  {
    name: 'integralCenter',
    path: '/integralCenter',
    component: () => import( /* webpackChunkName: 'integral_center' */  '@/components/integral/integral.vue'),
    meta: {
      title: '综合积分'
    }
  },
  //新个人中心
  {
    name: 'personalCenter',
    path: '/personalCenter',
    component: () => import( /* webpackMode: "lazy", webpackChunkName: "personal_center" */  '@/components/packages/personCenter/personCenter.vue'),
    meta: {
      title: '个人中心'
    }
  },
  //易聊
  {
    name: 'easyChat',
    path: '/easyChat',
    component: () => import( /* webpackChunkName: 'easy_chat' */  '@/components/website/easyChat.vue'),
    meta: {
      title: '易聊'
    }
  },
  //员工报表
  {
    name: 'workReport',
    path: '/workReport',
    component: () => import( /* webpackChunkName: 'work_report' */  '@/components/personal/workReport.vue'),
    meta: {
      title: '员工报表'
    }
  },
  //工作台
  {
    name: 'Workbench',
    path: '/workbench',
    component: () => import( /* webpackChunkName: 'workbench' */  '@/pages/workbench/index.vue'),
    meta: {
      title: '员工报表工作台'
    }
  },
  //自定义表单
  {
    name: 'customForm',
    path: '/customForm',
    component: () => import( /* webpackChunkName: 'customForm' */  '@/components/officeAutomatic/customForm/customForm.vue'),
    meta: {
      title: '编辑表单'
    }
  },
  {
    name: 'ImportExport',
    path: '/importExport',
    component: () => import( /* webpackChunkName: 'importExport' */  '@/pages/importExport/importExport.vue'),
    meta: {
      title: '导入导出',
      viewType: '1'
    }
  },
  {
    name: 'ImportExportStaff',
    path: '/importExportStaff',
    component: () => import( /* webpackChunkName: 'importExport' */  '@/pages/importExport/importExport.vue'),
    meta: {
      title: '导入导出-个人',
      viewType: '2'
    }
  },
  {
    name: 'Budget',
    path: '/budget',
    component: () => import( /* webpackChunkName: 'budget' */  '@/pages/budget/budget.vue'),
    meta: {
      title: '预算',
      componentName: 'Budget'
    }
  },
  {
    name: 'tagAudit',
    path: '/tagAudit',
    component: () => import( /* webpackChunkName: 'budget' */  '@/components/customer/tag/tagAudit'),
    meta: {
      title: '标签变更审核'
    }
  },
  // {
  //   name: 'ServiceManage',
  //   path: '/serviceManage',
  //   component: () => import( /* webpackChunkName: 'ServiceManage' */  '@/pages/product/serviceManage.vue'),
  //   meta: {
  //     title: '服务管理',
  //     componentName: 'ServiceManage'
  //   }
  // },
  // {
  //   name: 'ServiceProcessManage',
  //   path: '/processManage',
  //   component: () => import( /* webpackChunkName: 'ServiceManage' */  '@/pages/product/serviceProcessManage.vue'),
  //   meta: {
  //     title: '流程管理',
  //     componentName: 'ServiceProcessManage'
  //   }
  // },
  {
    name: 'HotRecommend',
    path: '/hotRecommend',
    component: () => import( /* webpackChunkName: 'ServiceManage' */  '@/pages/product/hotRecommend.vue'),
    meta: {
      title: '热门推荐',
      componentName: 'HotRecommend'
    }
  },
  {
    name: 'MyTaskList',
    path: '/myTaskList',
    component: () => import( /* webpackChunkName: 'myTaskList' */  '@/pages/my/myTask.vue'),
    meta: {
      title: '我的任务',
      componentName: 'MyTask'
    }
  },
  {
    name: 'AllOrder',
    path: '/allOrder',
    component: () => import( /* webpackChunkName: 'allOrder' */  '@/pages/order/orderList.vue'),
    meta: {
      title: '全部订单',
      componentName: 'OrderList'
    }
  },
  {
    name: 'MyOrderList',
    path: '/myOrderList',
    component: () => import( /* webpackChunkName: 'myOrderList' */  '@/pages/order/myOrderList.vue'),
    meta: {
      title: '我的订单',
      componentName: 'MyOrderList'
    }
  },
  {
    name: 'ServiceOrder',
    path: '/serviceOrder',
    component: () => import( /* webpackChunkName: 'serviceOrder' */  '@/pages/order/serviceOrder.vue'),
    meta: {
      title: '个人服务列表',
      componentName: 'ServiceOrder'
    }
  },
  {
    name: 'AllServiceOrder',
    path: '/allServiceOrder',
    component: () => import( /* webpackChunkName: 'allServiceOrder' */  '@/pages/order/allServiceOrder.vue'),
    meta: {
      title: '全部服务列表',
      componentName: 'AllServiceOrder'
    }
  },
  {
    name: 'HandoverNoteList',
    path: '/handoverNoteList',
    component: () => import( /* webpackChunkName: 'handoverNoteList' */  '@/pages/order/handoverNoteList.vue'),
    meta: {
      title: '交接单管理',
      componentName: 'HandoverNoteList'
    }
  },
  {
    name: 'OrderAudit',
    path: '/orderAudit',
    component: () => import( /* webpackChunkName: 'orderAudit' */  '@/pages/order/orderAudit.vue'),
    meta: {
      title: '审核管理',
      componentName: 'OrderAudit'
    }
  },
  {
    name: 'RenewalList',
    path: '/renewalList',
    component: () => import( /* webpackChunkName: 'renewalList' */  '@/pages/order/renewalList.vue'),
    meta: {
      title: '全部续费',
      componentName: 'RenewalList'
    }
  },
  {
    name: 'MyRenewalList',
    path: '/myRenewalList',
    component: () => import( /* webpackChunkName: 'myRenewalList' */  '@/pages/order/myRenewalList.vue'),
    meta: {
      title: '个人续费',
      componentName: 'MyRenewalList'
    }
  },
  {
    name: 'OrderRecycleBin',
    path: '/orderRecycleBin',
    component: () => import( /* webpackChunkName: 'orderRecycleBin' */  '@/pages/order/orderRecycleBin.vue'),
    meta: {
      title: '订单回收站',
      componentName: 'OrderRecycleBin'
    }
  },
  {
    name: 'RenewalStatistics',
    path: '/renewalStatistics',
    component: () => import( /* webpackChunkName: 'renewalStatistics' */  '@/pages/order/renewalStatistics.vue'),
    meta: {
      title: '全部续费统计',
      componentName: 'RenewalStatistics'
    }
  },
  {
    name: 'PartnerList',
    path: '/partnerList',
    component: () => import( /* webpackChunkName: 'partnerList' */  '@/pages/partner/partnerList.vue'),
    meta: {
      title: '合作商列表',
      componentName: 'PartnerList'
    }
  },
  {
    name: 'AddressChannel',
    path: '/addressChannel',
    component: () => import( /* webpackChunkName: 'addressChannel' */  '@/pages/partner/addressChannel.vue'),
    meta: {
      title: '地址渠道管理',
      componentName: 'AddressChannel'
    }
  },
  {
    name: 'AddressList',
    path: '/addressList',
    component: () => import( /* webpackChunkName: 'addressList' */  '@/pages/partner/addressList.vue'),
    meta: {
      title: '地址管理',
      componentName: 'AddressList'
    }
  },
  {
    name: 'BangBean',
    path: '/bangBean',
    component: () => import( /* webpackChunkName: 'bangBean' */  '@/pages/bangBean/bangBean.vue'),
    meta: {
      title: '邦邦豆',
      componentName: 'BangBean'
    }
  },
  {
    name: 'BookKeepingList',
    path: '/bookKeepingList',
    component: () => import( /* webpackChunkName: 'bookKeepingList' */  '@/pages/bookKeeping/bookKeepingList.vue'),
    meta: {
      title: '全部记账列表',
      componentName: 'BookKeepingList'
    }
  },
  {
    name: 'MyBookKeepingList',
    path: '/myBookKeepingList',
    component: () => import( /* webpackChunkName: 'myBookKeepingList' */  '@/pages/bookKeeping/myBookKeepingList.vue'),
    meta: {
      title: '个人记账列表',
      componentName: 'MyBookKeepingList'
    }
  },
  {
    name: 'interview',
    path: '/interview',
    component:() => import( /* webpackChunkName: 'budget' */  '@/components/interview/interview'),
    meta:{
      title: '面试'
    }
  },
  {
    name: 'LedgerManage',
    path: '/ledgerManage',
    component:() => import( /* webpackChunkName: 'ledgerManage' */  '@/pages/ledger/ledgerManage'),
    meta:{
      title: '账本管理',
      componentName: 'LedgerManage'
    }
  },
  {
    name: 'ProductManage',
    path: '/productManage',
    component:() => import( /* webpackChunkName: 'productManage' */  '@/pages/product/productManage'),
    meta:{
      title: '产品管理',
      componentName: 'ProductManage'
    }
  },
  {
    name: 'ProductStep',
    path: '/productStep',
    component:() => import( /* webpackChunkName: 'productManage' */  '@/pages/product/productStep'),
    meta:{
      title: '业务设置',
      componentName: 'ProductStep'
    }
  },
  {
    name: 'ProductAssociation',
    path: '/productAssociation',
    component:() => import( /* webpackChunkName: 'productAssociation' */  '@/pages/product/productAssociation'),
    meta:{
      title: '连带类型',
      componentName: 'ProductAssociation'
    }
  },
  {
    name: 'CommissionManage',
    path: '/commissionManage',
    component:() => import( /* webpackChunkName: 'commissionManage' */  '@/pages/commission/commissionManage'),
    meta:{
      title: '提成设置',
      componentName: 'CommissionManage'
    }
  },
  {
    name: 'OutputStatistics',
    path: '/outputStatistics',
    component:() => import( /* webpackChunkName: 'outputStatistics' */  '@/pages/ledger/outputStatistics'),
    meta:{
      title: '产值统计',
      componentName: 'outputStatistics'
    }
  },
  {
    name: 'MyRenewalStatistics',
    path: '/myRenewalStatistics',
    component: () => import( /* webpackChunkName: 'myRenewalStatistics' */  '@/pages/order/myRenewalStatistics.vue'),
    meta: {
      title: '个人续费统计',
      componentName: 'MyRenewalStatistics'
    }
  }
]
export { lazy }



// WEBPACK FOOTER //
// ./src/store/components/lazyLoading.js